import store from '../store'
import i18n from '../plugins/i18n'
import {Notify} from 'quasar-framework'

export default async (to, from, next) => {
    let greenGo = !!store.getters['auth/check']

    // Role check
    const user = store.getters['auth/user']
    let role = null
    let isActive = 0
    let urlOrder = null
    let lendingPointRoles = ['Lending Point', 'Lending Point Indirect', 'Lending Point Hostesses']

    if (user) {
        role = user.role ? user.role.name : null
        isActive = user.lending_point && lendingPointRoles.includes(role) ? user.lending_point.active: 0
        urlOrder = role.toLowerCase().replace(/[^\w ]+/g, '').replace(/ +/g, '-') + '.order'
    }

    if (to.meta.roles) greenGo = to.meta.roles.includes(role)
    if (to.meta.role) greenGo = to.meta.role == role
    if (to.meta.hasOwnProperty('mustBeActive')) greenGo = to.meta.mustBeActive === isActive    
    if (urlOrder === to.name && !user.enableCreateOrder) greenGo = false
    if (to.meta.checkExport && !user.can_export) greenGo = false

    // end role check
    // if (to.name != 'settings.password' && user && user.expiredPassword && user.auth_source !== 'OPEN') {
    //     Notify.create({
    //         color: 'warning',
    //         icon: 'warning',
    //         message: i18n.T('password expired'),
    //         detail: i18n.T('please, change your password.'),
    //         position: 'top'
    //     })
    //     next({name: 'settings.password'})
    // } else
    if (user) {
        if (!greenGo) {
            next({name: 'home'})
        } else {
            next()
        }
    } else {
        next({name: 'login'})
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/auth.js